import { createCategorySortCollator } from "./sortRowsByCategory";

export default function findCategoryJumpToIndex<T>(rows: readonly T[], getCategory: (row: T) => string, descending: boolean, category: string): number {
    const exactIndex = rows.findIndex(row => getCategory(row) === category);
    if (exactIndex >= 0) {
        return exactIndex;
    }
    
    const collator = createCategorySortCollator();
    const index = rows.findIndex(row => {
        const comparison = collator.compare(getCategory(row), category);
        return descending ? comparison <= 0 : comparison >= 0;
    });
    return index >= 0 ? index : rows.length - 1;
}
